module.exports = __webpack_public_path__ + "static/soBad-b88c158789bafa10dc5ac51eecfc0d53.jpg";